import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useSession } from "@/context/SessionContext";

interface ProtectedRouteProps {
  allow?: "candidate" | "admin";
  children: ReactNode;
}

export function ProtectedRoute({ allow, children }: ProtectedRouteProps) {
  const { isReady, session } = useSession();
  const redirectRole = allow ?? "candidate";

  if (!isReady) {
    return (
      <div className="mx-auto flex min-h-[60vh] max-w-6xl items-center justify-center px-6">
        <div className="panel max-w-md text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-moss/70">
            Loading portal
          </p>
          <h1 className="mt-4 text-3xl text-ink">Checking your session</h1>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate replace to={`/auth?role=${redirectRole}&mode=signin`} />;
  }

  if (allow && session.role !== allow) {
    return <Navigate replace to={session.role === "admin" ? "/admin" : "/candidate"} />;
  }

  return <>{children}</>;
}
